export function LoadingInformation() {
  return (
    <div id="loadingWindow" className="loading-window fs-1 hide-window">
      <div className="d-flex h-100 w-100 justify-content-center align-items-center">
        Loading...
      </div>
    </div>
  );
}
